var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.111,
    height: 20.028,
    viewBox: "0 0 20.111 20.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.594,3.23,16.954.589A1.948,1.948,0,0,0,14.205.7a1.95,1.95,0,0,0-.111,2.751l2.64,2.64a1.95,1.95,0,0,0,2.751-.111,1.949,1.949,0,0,0,.109-2.751ZM2.765,12.139l5.28,5.28,8.58-8.578-5.28-5.28-8.58,8.578ZM0,20.1l6.964-1.394-5.57-5.569Z",
    transform: "translate(0 -0.074)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.635e5b42965e31c54adf518ac227c238.svg";
export { ForwardRef as ReactComponent };